var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "v2",
      attrs: { visible: true, footer: null },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "custom-modal-content" }, [
        _c("div", { staticClass: "custom-modal-header" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("Assign Preferred Agent"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(
              "Select the preferred agent you want to assign to the visitor."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-modal-body" }, [
          _c("div", { staticClass: "pf-main" }, [
            _c("div", { staticClass: "pr-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText",
                  },
                ],
                attrs: { placeholder: "Temsilci arayın." },
                domProps: { value: _vm.searchText },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchText = $event.target.value
                    },
                    _vm.searchChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "material-icons mx-2 pr-icon" }, [
                _vm._v(" search "),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pr-items pr-item-wrapper" },
              _vm._l(_vm.filterUsers, function (agent) {
                return _c(
                  "div",
                  {
                    staticClass: "pr-item",
                    on: {
                      click: function ($event) {
                        return _vm.toggleAgent(agent._id)
                      },
                    },
                  },
                  [
                    _c("a-checkbox", {
                      staticClass: "segment-checkbox",
                      attrs: {
                        checked: _vm.selectedAgentIds.includes(agent._id),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleAgent(agent._id)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-data-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "user-data" },
                        [
                          _c("Avatar", {
                            staticClass: "mr-2 avatar",
                            attrs: {
                              size: 30,
                              src: agent.gravatar,
                              username: agent.name,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "metas" }, [
                            _c("div", { staticClass: "pr-item-name" }, [
                              _vm._v(_vm._s(agent.name)),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(_vm.getUserDepartmentNames(agent)) +
                                  "\n                                    "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pr-item-status",
                          attrs: {
                            "data-online":
                              _vm.$_.get(_vm.user, "_id") === agent._id
                                ? true
                                : agent.isOnline,
                            "data-status": agent.status.toLowerCase(),
                          },
                        },
                        [
                          _c("div", { staticClass: "pr-item-status-circle" }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(agent.status) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-modal-footer" }, [
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(" Cancel"),
              ]),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "pr-confirm-btn",
                  attrs: { type: "primary", disabled: !_vm.isChanged() },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("\n                    Confirm\n                ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }